import { render, staticRenderFns } from "./TheSpaceAddInstanceDialog.vue?vue&type=template&id=6bb08af8&"
import script from "./TheSpaceAddInstanceDialog.vue?vue&type=script&lang=js&"
export * from "./TheSpaceAddInstanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports